
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/react-stepper",
      function () {
        return require("private-next-pages/joy-ui/react-stepper.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/react-stepper"])
      });
    }
  